$(document).ready(function () {
    $(function () {
        var $pdpCarousel = $('#pdpCrossSellingJcarousel');
        var $cartCarousel = $('#cartCrossSellingJcarousel');
        var $currentCarousel = ($pdpCarousel.length !== 0) ? $pdpCarousel : $cartCarousel;
        var $currentProductNumber = $($currentCarousel.selector + ' ul li').length;
        var $minProductsForMobile = 1;
        var $minProductsForDesktop = 3;
        var $leftChevron = $('.chevron-left');
        var $rightChevron = $('.chevron-right');

        if ((IsMobile.any() && $currentProductNumber > $minProductsForMobile) ||
            (IsMobile.any() == null && ($currentCarousel === $pdpCarousel && $currentProductNumber > $minProductsForMobile) ||
            ($currentCarousel === $cartCarousel && $currentProductNumber > $minProductsForDesktop))
        ) {
            $currentCarousel
                .jcarousel({
                    wrap: 'circular',
                    center: true,
                    animation: 0
                })
                .jcarouselAutoscroll({
                    interval: 6000
                });
            $currentCarousel.on('jcarousel:animate', function (event, carousel) {
                $(carousel._element.context).find('li').hide().fadeIn(1000);
                adjustCarouselHeight($currentCarousel);
            });

            $currentCarousel.on('jcarousel:animateend', function (event, carousel) {
                adjustCarouselHeight($currentCarousel);
            });

            $leftChevron.on('click', function () {
                $currentCarousel.jcarousel('scroll', '-=1');
                adjustCarouselHeight($currentCarousel);
            });

            $rightChevron.on('click', function () {
                $currentCarousel.jcarousel('scroll', '+=1');
                adjustCarouselHeight($currentCarousel);
            });
        } else {
            $leftChevron.hide();
            $rightChevron.hide();
        }
    });

    function adjustCarouselHeight($currentCarousel) {
        var $pdpCarouselElement = $('#pdpCrossSellingJcarousel ul :first-child');
        var $cartCarouselElement = $('#cartCrossSellingJcarousel ul :first-child');
        var $carouselElement = ($pdpCarouselElement.length !== 0) ? $pdpCarouselElement : $cartCarouselElement;
        var offsetHeight = $carouselElement[0].offsetHeight;
        if (offsetHeight === 0) {
            return;
        }
        $currentCarousel.height(offsetHeight);
    }
});


$(window).on("load resize", function() {
    var $pdpCarousel = $('#pdpCrossSellingJcarousel');
    var $cartCarousel = $('#cartCrossSellingJcarousel');
    var $currentCarousel = ($pdpCarousel.length !== 0) ? $pdpCarousel : $cartCarousel;
    var $pdpCarouselElement = $('#pdpCrossSellingJcarousel ul :first-child');
    var $cartCarouselElement = $('#cartCrossSellingJcarousel ul :first-child');
    var $carouselElement = ($pdpCarouselElement.length !== 0) ? $pdpCarouselElement : $cartCarouselElement;
    if(typeof  $carouselElement[0] !== 'undefined') {
        $currentCarousel.height($carouselElement[0].offsetHeight);
    }
});